<script setup lang="ts">
const route = useRoute()
const store = useAppStore()

const isMounted = ref(false)
const isVisible = useState('menu')
const isMenuMinimized = ref(false)
const mixBlendActive = useState('mixBlend', () => false)
const lastScrollTop = ref(0)

const onScroll = useDebounceFn(() => {
  const st = window.scrollY || document.documentElement.scrollTop
  if (import.meta.client) {
    if (lastScrollTop.value > 160) {
      mixBlendActive.value = true
    } else {
      mixBlendActive.value = false
    }

    if (st > lastScrollTop.value && st > 104) {
      // downscroll
      isMenuMinimized.value = true
    } else if (st < lastScrollTop.value) {
      // upscroll
      isMenuMinimized.value = false
    }

    lastScrollTop.value = st <= 0 ? 0 : st // For Mobile or negative scrolling
  }
}, 5)

watch(
  () => route.fullPath,
  () => {
    useTimeoutFn(() => {
      lastScrollTop.value = 0
      mixBlendActive.value = false
      isMenuMinimized.value = false
    }, 1000)
  }
)

onMounted(() => {
  isMounted.value = true
  window.addEventListener('scroll', onScroll)
})

onUnmounted(() => {
  window.removeEventListener('scroll', onScroll)
})
</script>
<template>
  <header
    class="fixed top-0 z-20 min-h-20 w-full pt-4 duration-500 [transition-property:transform,opacity] lg:min-h-[104px] lg:pt-6"
    :class="[
      isMounted ? 'opacity-100' : 'opacity-0',
      isMenuMinimized ? '-translate-y-20 lg:-translate-y-[104px]' : 'translate-y-0',
      isVisible
        ? 'text-yellow'
        : !mixBlendActive
          ? store.theme === 'light'
            ? 'text-yellow'
            : 'text-black'
          : '',
      mixBlendActive && 'mix-blend-difference'
    ]"
  >
    <MenuBackDrop />
    <div class="relative z-[4] flex items-center justify-between px-4 lg:px-8">
      <MenuButton />
      <Logo class="h-10 w-10 max-w-10" />
      <div class="hidden uppercase lg:block">Pakt Media &copy;</div>
    </div>
    <Teleport to="body">
      <MenuList :data="store.allMenuItems" />
    </Teleport>
  </header>
</template>
